import { createContext, useEffect, useState } from 'react';
import SendDocumentsOnboarding from '@src/views/dashboard/Onboarding/SendDocumentsOnboarding';

type SendForValidateOnboardingData = {
  close(): string;
};
export const SendForValidateOnboardingContext = createContext(
  {} as SendForValidateOnboardingData
);

export const SendForValidateOnboardingProvider: React.FC = ({ children }) => {
  const close = () => {
    return '';
  };

  return (
    <SendForValidateOnboardingContext.Provider value={{ close }}>
      <>
        <div>
          <SendDocumentsOnboarding />
        </div>
        {children}
      </>
    </SendForValidateOnboardingContext.Provider>
  );
};
